// Libs
import { createSelector } from 'reselect'

// Selectors
import selectedSeasonId$ from './selectedSeasonId'
import { seasons$ } from 'fc-seasons'

export default createSelector(
  [
    selectedSeasonId$,
    seasons$,
  ],
  (seasonid, seasons) => {
    return seasons[seasonid] || null
  })
